export var SortOrder;
(function (SortOrder) {
    SortOrder["Ascending"] = "asc";
    SortOrder["Descending"] = "desc";
})(SortOrder || (SortOrder = {}));
//# sourceMappingURL=sortOrder.js.map